// extracted by mini-css-extract-plugin
export default {"Link":"ButtonSeeDetailsProjects_Link__a4y1Q","buttonSeeDetailsProject":"ButtonSeeDetailsProjects_buttonSeeDetailsProject__e5gNn"};